import { render } from "./productBox.vue?vue&type=template&id=8ec239aa&ts=true"
import script from "./productBox.vue?vue&type=script&lang=ts"
export * from "./productBox.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__